import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-LN/SafeDrivingContentsLN/.eu';
import Na from '@di-shared/features/safe-driving-LN/SafeDrivingContentsLN/.na';

export interface SafeDrivingContentsLNProps {
  vin: string;
}

export default function SafeDrivingContentsLN({vin}: SafeDrivingContentsLNProps) {
  return (
    <>
      <Environment.Eu>
        <Environment.Kia>
          <Eu vin={vin} />
        </Environment.Kia>
      </Environment.Eu>
      <Environment.Na>
        <Environment.Kia>
          <Na vin={vin} />
        </Environment.Kia>
      </Environment.Na>
    </>
  );
}
